import Vue from 'vue';
import App from './App.vue';
import store from './store/store';
import './assets/app.scss';

Vue.filter('getProductImage', product => (product.images.length > 0) ? product.images[0].src : '');

Vue.filter('moneyFormat', (product) => {
  if (product.variants) {
    return `$${product.variants[0].price}`;
  }
  return '';
});

Vue.filter('getProductDesc', product => {
  return product.body_html.replace( /(<([^>]+)>)/ig, '');
});

Vue.filter('getProductVariantImage', function (product,variantId){
  var productVariantImage = product.variants.find(x => x.id == variantId).featured_image;
  if(productVariantImage){
    return productVariantImage.src;
  }
  return (product.images.length > 0) ? product.images[0].src : '';
  });

/* eslint-disable no-unused-vars */
const ShoppeApp = new Vue({
  el: '#Shoppe',
  data: {
    currentPage: 1,
  },
  store,
  created() {
    this.$store.dispatch('getProducts');
  },
  render: h => h(App),
});
